import { isAxiosError } from 'axios';

import { OPF_RETRY_RESPONSE_STATUSES } from 'config/constants.ts';

export function isErrorNeedsRetry(error: any): boolean {
    return (
        isAxiosError(error) &&
        !!error.response?.status &&
        OPF_RETRY_RESPONSE_STATUSES.includes(error.response.status)
    );
}
